import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '../../../ts/ServerApi/types/actionParams';

export class RenameWorkbookRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameWorkbook', {
      id: id,
      name: name
    });
  }
}
